//export const BASE_URL = '//localhost:8000/api';
export const BASE_URL = '/api';
//export const BASE_URL = '/172.16.21.229:88/api';

  function checkResponseSignIn(res) {
    if (res.ok) {
      return res.json();
    }
      return Promise.reject(`Ошибка: ${res.status}`);
  }


  function checkResponse(res) {
    
    if (res.ok) {
      return res.json();
    } else if(res.status === 500) {
      return Promise.reject(res.status)
    } else {
      return res.json()
      .then(data => {
        const errorMessage = JSON.stringify(data);
        return Promise.reject(`${errorMessage}`); 
      });
    }
  }
  

export const register = ( {username, email, password } ) => {
  return fetch(`${BASE_URL}/users/`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      username: username,
      email: email,
      password: password,
      })
  }).then((res) => {
    return checkResponse(res);
  });
}; 

export const authorize = ( { username, password} ) => {
  return fetch(`${BASE_URL}/jwt/create/`, {
      method: "POST",
      headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
      },
      body: JSON.stringify({ 
        username: username, 
        password: password,
      })
  })
      .then(checkResponseSignIn)
};

export const getOneTask = (id) => {
  return fetch(`${BASE_URL}/tasks/${id}`, {
      method: "GET",
      headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${JSON.parse(localStorage.getItem("token"))}`
      },
  })
      .then(checkResponse)
};

export const getUser = (token) => {
  return fetch(`${BASE_URL}/users/me/`, {
      method: "GET",
      headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      },
  })
      .then(checkResponse)
};

export const getContent = (token) => {
  return fetch(`${BASE_URL}/tasks/`, {
      method: "GET",
      headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
      },
  })
      .then(checkResponse)
};

export const sendSolve = ({task, solution}) => {
  const token = localStorage.getItem('token')
  const parsedToken = JSON.parse(token);
  return fetch(`${BASE_URL}/tries/`, {
      method: "POST",
      headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          "Authorization": `Bearer ${parsedToken}`
      },
      body: JSON.stringify({ 
        task: task,
        solution: solution, 
      })
  })
  .then((res) => {
    return checkResponse(res);
  });
};